import { useSegmentFilterCascaded } from "@repo/baseCloud";
import { BrandsDropdown, ChannelsDropdown, MarketersDropdown, StatesDropdown } from "@repo/baseCloud/components";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { ClientSideLabel } from "./clientSideLabel";

interface SegmentDropdownsProps extends LayerFilterProps {
	clientSide: boolean;
}

export function SegmentDropdowns({ layer, updateFilter, clientSide }: SegmentDropdownsProps) {
	const segmentFilter = useSegmentFilterCascaded(layer);
	const label = (text: string) => (clientSide ? <ClientSideLabel label={text} /> : text);
	const shared = { changeHandler: updateFilter, maxSelectedDisplay: 3, allOption: !clientSide };

	return (
		<>
			<BrandsDropdown
				{...shared}
				label={label("Brands")}
				options={segmentFilter.brands}
				loaded={segmentFilter.brandsLoaded}
				value={layer.brandIds ?? []}
			/>
			<MarketersDropdown
				{...shared}
				label={label("Marketers")}
				options={segmentFilter.marketers}
				loaded={segmentFilter.marketersLoaded}
				value={layer.marketerIds ?? []}
			/>
			<ChannelsDropdown
				{...shared}
				label={label("Channels")}
				options={segmentFilter.channels}
				loaded={segmentFilter.channelsLoaded}
				value={layer.channelIds ?? []}
			/>
			<StatesDropdown
				{...shared}
				label={label("States")}
				options={segmentFilter.states}
				loaded={segmentFilter.statesLoaded}
				value={layer.stateIds ?? []}
			/>
		</>
	);
}
